export default __webpack_public_path__ + "static/media/made_with_love.74a7c067.svg";